import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';

import { DetailButton } from 'modules/layout';

import DeleteImageMap from '../../containers/DeleteImageMap';

import rule from './ImageActions.rule';

const ImageActions = ({ url, firestoreId }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <DetailButton url={url} />
            <DeleteImageMap id={firestoreId} />
        </div>
    );
};

ImageActions.propTypes = {
    url: PropTypes.string.isRequired,
    firestoreId: PropTypes.string.isRequired,
};

export default ImageActions;
